import {
  SelectFromInfiniteQuery,
  SelectFromInfiniteQueryProps,
} from "./SelectFromInfiniteQuery"
import { useTranslation } from "react-i18next"
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query"
import { getSimplePersons } from "@/orval/gen"
import {
  GetSimplePersonsParams,
  SimplePersonPagination,
} from "@/orval/gen/model"
import { fetchSimplePersonById } from "@/-dataloaders/simple-persons"
import { useDefaultInfiniteQuery } from "@/utils/useDefaultInfiniteQuery"

interface Props extends Omit<
  SelectFromInfiniteQueryProps<
    UseInfiniteQueryResult<InfiniteData<SimplePersonPagination>>
  >,
  "queryData" | "entitiesToComboboxData"
> {
  filterOptions?: Omit<
    GetSimplePersonsParams,
    "pageParam" | "pageSize" | "searchValue"
  >
}

export function InfinitePersonMultiSelect({
  filterOptions = {},
  ...props
}: Props) {
  const { t } = useTranslation("app_server")
  const [searchValue, setSearchValue] = React.useState("")

  return (
    <SelectFromInfiniteQuery
      multiple={true}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      entitiesToComboboxData={(person) => ({
        label: person.name,
        value: person.personId.toString(),
      })}
      label={t("Persons")}
      placeholder={t("SearchPerson")}
      {...props}
      queryData={useDefaultInfiniteQuery(getSimplePersons, (pageRequest) => ({
        ...pageRequest,
        searchValue,
        ...filterOptions,
      }))}
      fetchSelectedItem={fetchSimplePersonById}
      getSelectedItemQueryKey={(id) => ["SimplePerson", parseInt(id, 10)]}
    />
  )
}
